export const Colors = {
    primaryOrange: '#E15631'
}